import {
  BooleanOperator,
  Features,
  type QueryBuilderSubquery,
} from '@ardoq/api-types';
import { AppModules } from 'appContainer/types';
import { decodeSubquery, encodeSubquery } from 'encodeDecodeSubquery';
import { featureFlagBoundary } from 'router/declarative/featureFlagBoundary';
import { param, stringParam } from 'router/declarative/paramRegistry';
import type {
  IndexRouteContent,
  PathRouteContent,
  RouteNode,
} from 'router/declarative/routeNode';

const emptySubquery: QueryBuilderSubquery = {
  condition: BooleanOperator.AND,
  rules: [],
};

const inventoryFilters = param<QueryBuilderSubquery>({
  fromString: value => decodeSubquery(value) ?? emptySubquery,
  toString: encodeSubquery,
});

export const routes = {
  path: '/inventory',
  appModule: AppModules.INVENTORY,
  title: 'Data Inventory',
  hiddenParams: ['inventoryViewState'],
  children: [
    {
      path: { index: true },
      content: async (): IndexRouteContent =>
        (await import('./dataOverview/DataOverview')).DataOverview,
    },
    {
      path: '/overview',
      content: async (): PathRouteContent =>
        (await import('./dataOverview/DataOverview')).DataOverview,
    },
    {
      path: '/browse',
      title: 'Browse data',
      searchParams: { componentOverview: stringParam },
      children: [
        {
          path: { index: true },
          content: async (): IndexRouteContent =>
            (await import('./dataOverview/DataOverview')).DataOverview,
        },
        {
          path: '/workspace',
          children: [
            {
              path: '/:workspaceIds',
              searchParams: { inventoryFilters },
              content: async (): PathRouteContent =>
                (await import('./Inventory')).Inventory,
            },
          ],
        },
        {
          path: '/component-type',
          children: [
            {
              path: '/:componentTypeIds',
              searchParams: { inventoryFilters },
              content: async (): PathRouteContent =>
                (await import('./Inventory')).Inventory,
            },
          ],
        },
        {
          path: '/report',
          children: [
            {
              path: '/:reportId',
              content: async (): PathRouteContent =>
                (await import('./Inventory')).Inventory,
            },
          ],
        },
        {
          path: '/datasets',
          title: 'Datasets',
          content: async (): PathRouteContent =>
            (await import('./Inventory')).Inventory,
        },
        {
          path: { layout: true },
          content: featureFlagBoundary(
            [Features.PERSON_IN_GRAPH_PERMISSIONS_PROTOTYPE],
            {
              pageName: 'My Applications',
              message:
                'This feature is not available for your organization. Contact your admin if you need access to it.',
            }
          ),
          children: [
            {
              path: '/my-applications',
              title: 'My Applications',
              content: async (): PathRouteContent =>
                (await import('./Inventory')).Inventory,
            },
          ],
        },
      ],
    },
  ],
} as const satisfies RouteNode;
